var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleGame11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 89,
    viewBox: "0 0 60 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.8364 81.712H23.1264V83H18.2404V73.27H19.8364V81.712ZM25.2731 74.264C24.9838 74.264 24.7411 74.166 24.5451 73.97C24.3491 73.774 24.2511 73.5313 24.2511 73.242C24.2511 72.9527 24.3491 72.71 24.5451 72.514C24.7411 72.318 24.9838 72.22 25.2731 72.22C25.5531 72.22 25.7911 72.318 25.9871 72.514C26.1831 72.71 26.2811 72.9527 26.2811 73.242C26.2811 73.5313 26.1831 73.774 25.9871 73.97C25.7911 74.166 25.5531 74.264 25.2731 74.264ZM26.0571 75.286V83H24.4611V75.286H26.0571ZM31.1345 81.572L33.3185 75.286H35.0125L32.0725 83H30.1685L27.2425 75.286H28.9505L31.1345 81.572ZM43.2889 78.954C43.2889 79.2433 43.2703 79.5047 43.2329 79.738H37.3389C37.3856 80.354 37.6143 80.8487 38.0249 81.222C38.4356 81.5953 38.9396 81.782 39.5369 81.782C40.3956 81.782 41.0023 81.4227 41.3569 80.704H43.0789C42.8456 81.4133 42.4209 81.9967 41.8049 82.454C41.1983 82.902 40.4423 83.126 39.5369 83.126C38.7996 83.126 38.1369 82.9627 37.5489 82.636C36.9703 82.3 36.5129 81.8333 36.1769 81.236C35.8503 80.6293 35.6869 79.9293 35.6869 79.136C35.6869 78.3427 35.8456 77.6473 36.1629 77.05C36.4896 76.4433 36.9423 75.9767 37.5209 75.65C38.1089 75.3233 38.7809 75.16 39.5369 75.16C40.2649 75.16 40.9136 75.3187 41.4829 75.636C42.0523 75.9533 42.4956 76.4013 42.8129 76.98C43.1303 77.5493 43.2889 78.2073 43.2889 78.954ZM41.6229 78.45C41.6136 77.862 41.4036 77.3907 40.9929 77.036C40.5823 76.6813 40.0736 76.504 39.4669 76.504C38.9163 76.504 38.4449 76.6813 38.0529 77.036C37.6609 77.3813 37.4276 77.8527 37.3529 78.45H41.6229Z",
    fill: "#F4F3FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_608_8397)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "#FFCACA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7524 21.1723C31.7502 21.0961 31.6671 21.0464 31.6016 21.0855C28.1363 23.1558 28.2004 28.3491 28.2418 29.2901C28.2449 29.3611 28.1778 29.4112 28.1135 29.3809C27.7132 29.1924 26.5661 28.4823 26.5027 26.5153C26.5003 26.439 26.4179 26.3899 26.3522 26.4289C24.3458 27.6181 23 29.8144 23 32.25C23 35.978 26.134 39 30 39C33.866 39 37 35.978 37 32.25C37 26.8342 31.8803 25.6694 31.7524 21.1723Z",
    fill: "#2A2A2B",
    stroke: "#2A2A2B",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_608_8397",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_608_8397"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_608_8397"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleGame11);
export default __webpack_public_path__ + "static/media/Title Game (11).76146cf88f09823dd149d6bc511a7e3c.svg";
export { ForwardRef as ReactComponent };